import { createRoot } from "react-dom/client";

import { installPlayer } from "@edclub/appmanager-client/legacy-install";
import { renderPlayer } from "@edclub/player";

import App from "./App";

import "./index.css";

installPlayer().then(() => {
  window.approuter.registerSampleActivityFiles(["configs/config_1.json"]);

  window.approuter.registerStart(() => {
    renderPlayer(createRoot(document.getElementById("root")!), {
      App,
    });
  });
  window.approuter.establishEventManagerChannel();
});
